<navigation></navigation>
<div class="container">
  <div class="row">
    <div class="col-lg-3">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-12">
          <news-container />
        </div>
        <div class="col-12 col-md-6 col-lg-12">
          <notification-container
            [messages]="customerActivities()"
            notificationType="unplanned"
          ></notification-container>
        </div>
        <div class="col-12 col-md-6 col-lg-12">
          <notification-container
            [messages]="customerNotifications()"
            notificationType="planned"
          ></notification-container>
        </div>
      </div>
    </div>
    <div class="col-lg-9">
      <div class="row">
        <div class="col-lg-8 col--flex">
          <combined-service-tile [subscriptions]="topSubscriptions"></combined-service-tile>
        </div>
        <div class="col-lg-4">
          @for (subscription of sideSubscriptions; track subscription.key) {
            <div>
              <dashboard-tile [subscription]="subscription" [customerActivities]="customerActivities()" />
            </div>
          }
          @if (ipPrefixesAvailable()) {
            <surfcert-container />
          }
        </div>
      </div>

      <div class="row">
        @for (subscription of bottomSubscriptions; track subscription.key) {
          <div class="col-md-6 col-lg-4 col--flex">
            <dashboard-tile [subscription]="subscription" [customerActivities]="customerActivities()" />
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div class="container">
  <footer></footer>
</div>
